// 다이얼로그를 이용한 메시지 박스 표시 글로벌 메소드.
export default {
  /**
   * 대상 글로벌 속성으로 이용할
   * vuetify dialog 메세지의 데이터 속성 변경 메소드
   */
  computed: {

  },
  methods: {
    async $rxConfirm(type, title, message, options) {
      // 유형과 메시지, 기타 옵션
      if(options === undefined) {
        options = {};
      }
      // options.messageType = type;
      // options.dialog = true;
      // options.title = title;
      // options.message = message;
      options.boxType = "confirm";
      // return await this.$store.dispatch("app/openMessageBox", options);
      return await this.openMessageBox(type, title, message, options);
    },
    async $rxAlert(type, title, message, options) {
      // 유형과 메시지, 기타 옵션
      if(options === undefined) {
        options = {};
      }
      // options.messageType = type;
      // options.dialog = true;
      // options.title = title;
      // options.message = message;
      options.boxType = "alert";
      // return await this.$store.dispatch("app/openMessageBox", options);
      return await this.openMessageBox(type, title, message, options);
    },
    async openMessageBox(type, title, message, options) {
      options.messageType = type;
      options.dialog = true;
      options.title = title;
      options.message = message;
      return await this.$store.dispatch("app/openMessageBox", options);
    },
    $rxSnackbar: function(type, message, options) {
      if(options === undefined) {
        options = {};
      }
      options.type = type;
      options.text = message;
      options.show = true;
      if (!options.y) {
        options.y = "bottom";
      }
      switch (options.type) {
        case "info":
          options.color = "info";
          break;
        case "warning":
          options.color = "warning darken-2";
          break;
        case "success":
          options.color = "success";
          break;
          case "error":
            options.color = "error";
          break;
        default:
          break;
      }
      this.$store.dispatch("app/setSnackbar", options);
    },
  },
};
